import { useSnapshot } from 'valtio';
import Button from '~/components2/forms/Button';
import layerStore from '~/store2/layers';
import { METADATA_SIDEBAR_WIDTH } from '../MetadataSidebar/MetadataSidebar';
import { LEGEND_PANEL_ID } from './Legend';

type LegendButtonProps = {
  // When the metadata sidebar is docked (360px, right-0), shift left so it isn't covered (CG-855).
  metadataSidebarOpen?: boolean;
};

export const LegendButton = ({ metadataSidebarOpen }: LegendButtonProps) => {
  const { isLegendVisible } = useSnapshot(layerStore) as typeof layerStore;

  const onButtonClick = () => {
    layerStore.toggleLegend();
  };

  return (
    // right-4 (16px) default gutter, plus the sidebar's width when docked — clamped via min() to
    // track the sidebar's own max-w-[85%] clamp on narrow screens (CG-855).
    <div
      className="absolute bottom-8 z-10"
      style={{ right: metadataSidebarOpen ? `calc(min(${METADATA_SIDEBAR_WIDTH}px, 85%) + 16px)` : 16 }}
    >
      <Button
        alternate
        size="icon"
        icon={isLegendVisible ? 'chevronRight' : 'legend'}
        onClick={onButtonClick}
        iconSize={18}
        aria-label="Legend"
        aria-expanded={isLegendVisible}
        aria-controls={LEGEND_PANEL_ID}
        data-testid="map-legend-button"
      />
    </div>
  );
};
